export const PROD_SERVESYNC_HOST = 'servesynctennis.com'

export function isProdServeSyncHost(host) {
  if (!host) return false
  const normalizedHost = String(host).split(',')[0].trim().toLowerCase()
  return (
    normalizedHost === PROD_SERVESYNC_HOST ||
    normalizedHost.startsWith(`${PROD_SERVESYNC_HOST}:`)
  )
}

export function isProdServeSyncRuntime() {
  if (typeof window === 'undefined') return false
  return isProdServeSyncHost(window.location.host || window.location.hostname)
}
